import clsx from 'clsx';
import React, { useState } from 'react';
import classNames from 'classnames';

import { useOnboardingContext } from '../../../onboarding.context';
import { useReportBuilderContext } from '../../../report-builder.context';
import { ONBOARDING_STEPS } from '../../../types';

import arrow1 from './arrow1.png';
import arrow2 from './arrow2.png';
import arrow3 from './arrow3.png';
import arrow4 from './arrow4.png';
import styles from './onboarding-arrows.scss';

interface OnboardingArrowsProps {
  position: 'sidebar' | 'sidebarMenu' | 'report' | 'root';
}

const ImageWithTransition = ({ imageSrc, className, alt }: { imageSrc: string; className: string; alt: string }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsImageLoaded(true);
  };

  return (
    <div
      className={classNames(className, styles.imageContainer, {
        [styles.fadeIn]: isImageLoaded
      })}
    >
      <img src={imageSrc} alt={alt} onLoad={handleImageLoad}/>
    </div>
  );
};

export const OnboardingArrows = ({ position }: OnboardingArrowsProps) => {
  const { isOnboarding, pageSetup } = useReportBuilderContext();
  const { currentStep, isNextEnabled } = useOnboardingContext();

  if (!isOnboarding) {
    return null;
  }

  const getSidebarArrow = () => {
    if (position === 'sidebar') {
      if (currentStep === ONBOARDING_STEPS.ADD_TEMPLATE && !isNextEnabled) {
        return { classes: [styles.addTemplate], icon: arrow1 };
      }
      if (currentStep === ONBOARDING_STEPS.ADD_WIDGET && !isNextEnabled) {
        return { classes: [styles.addWidget], icon: arrow1 };
      }
    }
  };

  const getSidebarMenuArrow = () => {
    if (position === 'sidebarMenu') {
      if (currentStep === ONBOARDING_STEPS.SELECT_WIDGET && isNextEnabled) {
        return { classes: [styles.selectedChart], icon: arrow2 };
      }
      if (currentStep === ONBOARDING_STEPS.ADD_TEXT_IMAGES) {
        return { classes: [styles.addTextImages], icon: arrow3 };
      }
    }
  };

  const getReportArrow = () => {
    if (position === 'report') {
      if (currentStep === ONBOARDING_STEPS.SELECT_WIDGET && !isNextEnabled) {
        return { classes: [styles.selectChart], icon: arrow1 };
      }
    }
  };

  const getRootArrow = () => {
    if (position === 'root') {
      if (currentStep === ONBOARDING_STEPS.SEE_HELP) {
        return { classes: [styles.seeHelp], icon: arrow4 };
      }
    }
  };

  const arrow = getSidebarArrow() || getSidebarMenuArrow() || getReportArrow() || getRootArrow();

  return arrow ? (
    <ImageWithTransition
      imageSrc={arrow.icon}
      className={clsx(styles.arrow, styles[pageSetup.orientation], ...arrow.classes)}
      alt="arrow"
    />
  ) : null;
};
